import { subscriptionsCrudStateConfig } from "seneca-common/features/subscriptions/state/consts";
import { makeCrudStateActionFactories } from "seneca-common/utils/apiStates";

export const {
  fetchAllActionFactory: fetchAllSubscriptionsActionFactory,
  fetchActionFactory: fetchSubscriptionActionFactory,
  updateActionFactory: updateSubscriptionActionFactory,
  createActionFactory: createSubscriptionActionFactory
} = makeCrudStateActionFactories(subscriptionsCrudStateConfig);
